export const imageKeyOverrides = {
  '2RQ08A': '2RQ08A',
  '2RQ08B': '2RQ08A',
  '2RQ08C': '2RQ08A',
  '2RQ08D': '2RQ08A',
  '2RQ08F': '2RQ08A',
  '2RQ08H': '2RQ08A',
  '2RQ08V': '2RQ08A',
  '2RQ09A': '2RQ08A',
  '2RQ09B': '2RQ08A',
  '2RQ09C': '2RQ08A',
  '2RQ09D': '2RQ08A',
  '2RQ09H': '2RQ08A',
  '2RQ09J': '2RQ08A',
  '2RQ09K': '2RQ08A',
  '2RQ10A': '2RQ08A',
  '2RQ10B': '2RQ08A',
  '2RQ10C': '2RQ08A',
  '2RQ10F': '2RQ08A',
  '2RQ11A': '2RQ08A',
  '2RQ11B': '2RQ08A',
  '2RQ11C': '2RQ08A',
  '2RQ20A': '2RQ08A',
  '2RQ20B': '2RQ08A',
  '2RQ20C': '2RQ08A',
  '2RQ20D': '2RQ08A',
  '2RQ20J': '2RQ08A',
  '2RQ20K': '2RQ08A',
  '2RQ20L': '2RQ08A',
  '2RQ21A': '2RQ08A',
  '2RQ21B': '2RQ08A',
  '2RQ21D': '2RQ08A',
  '2RQ22A': '2RQ08A',
  '6CC85A': '2RQ08A',
  'CZ309A': '2RQ08A',
  'CZ309B': '2RQ08A',
  'CZ309F': '2RQ08A',
  'CZ310A': '2RQ08A',
  'CZ310B': '2RQ08A',
  'CZ310C': '2RQ08A',
  'CZ310D': '2RQ08A',
  'CZ310F': '2RQ08A',
  'CZ311A': '2RQ08A',
  'CZ311B': '2RQ08A',
  'CZ311C': '2RQ08A',
  'CZ311D': '2RQ08A',
  'CZ311F': '2RQ08A',
  'CZ312A': '2RQ08A',
  'CZ312B': '2RQ08A',
  'CZ312C': '2RQ08A',
  'CZ312D': '2RQ08A',
  'CZ312E': '2RQ08A',
  'CZ312F': '2RQ08A',
  'CZ312G': '2RQ08A',
  'CZ312H': '2RQ08A',
  'CZ313A': '2RQ08A',
  '4VW12B': '4VW12A',
  '4VW12F': '4VW12A',
  '4VW12H': '4VW12A',
  '4VW13A': '4VW11A',
  '4VW13B': '4VW11A',
  '4VW13F': '4VW11A',
  '4VW13H': '4VW11A',
  '4VW14A': '4VW12A',
  '4VW14B': '4VW12A',
  '4VW14C': '4VW12C',
  '4VW14F': '4VW12A',
  '4VW14G': '4VW12A',
  '4VW14H': '4VW12A',
  '4VW15A': '4VW11A',
  '4VW15B': '4VW11A',
  '4VW15C': '4VW13C',
  '4VW15F': '4VW11A',
  '4VW15G': '4VW11A',
  '4VW15H': '4VW11A',
  '4VW16B': '4VW16A',
  '4VW16F': '4VW16A',
  '4VW16H': '4VW16A',
  '4VW17B': '4VW17A',
  '4VW17F': '4VW17A',
  '4VW17H': '4VW17A',
  '4VW18B': '4VW18A',
  '4VW18F': '4VW18A',
  '50V69A': '4WY85A',
  '50V69C': '50V69B',
  '50V68A': '8AG14A',
  '50P69A': '8VK20A',
  '227Z8A': '227Z7A',
  '227Z8C': '227Z7B',
  '7QR88A': '7QR88A',
  '7QR88B': '7QR88A',
  '7QR88F': '7QR88A',
  '7QR88G': '7QR88A',
  '7QR88H': '7QR88A',
  '7QR88M': '7QR88A',
  '7QR88S': '7QR88A',
  '6KD23A': '6KD23A',
  '6KD23H': '6KD23A',
  '6KD24A': '6KD23A',
  '6KD24F': '6KD23A',
  '6KD24H': '6KD23A',
  '6KD25A': '6KD23A',
  '6KD25H': '6KD23A',
  '6KD26A': '6KD23A',
  '6KD26F': '6KD23A',
  '6KD26H': '6KD23A',
  '9T922A': '3R745A',
  '9T923A': '3R745A',
  '9T924A': '3R745A',
  '9T925A': '3R745A',
  '9T922C': '3R745A',
  '9T923C': '3R745A',
  '9T924C': '3R745A',
  '9T925C': '3R745A',
};
